import Vue from 'vue'
import Vuex from 'vuex'

const LOGIN = "LOGIN";
const LOGIN_SUCCESS = "LOGIN_SUCCESS";
const LOGOUT = "LOGOUT";
const UPDATE_PERMISSIONS = "UPDATE_PERMISSIONS";

Vue.use(Vuex);

export default new Vuex.Store({
  state: {
    isLoggedIn: localStorage.getItem("token"),
    role: localStorage.getItem("role"),
    permissions: localStorage.getItem("permissions")
  },
  mutations: {
    [LOGIN](state) {
      state.pending = true;
    },
    [LOGIN_SUCCESS](state) {
      state.isLoggedIn = true;
      state.role = localStorage.getItem("role");
      state.permissions = localStorage.getItem("permissions");
      state.pending = false;
    },
    [LOGOUT](state) {
      state.isLoggedIn = false;
      state.role = null;
      state.permissions = null;
    },
    [UPDATE_PERMISSIONS](state) {
      state.role = localStorage.getItem("role");
      state.permissions = localStorage.getItem("permissions");
    }
  },
  actions: {
    login({
            state,
            commit,
            rootState
          }, creds) {
      localStorage.setItem("role", creds.role);
      localStorage.setItem("permissions", creds.permissions);
      commit(LOGIN); // show spinner
      return new Promise(resolve => {
        setTimeout(() => {
          localStorage.setItem("token", creds.token);
          localStorage.setItem("role", creds.role);
          localStorage.setItem("permissions", creds.permissions);
          commit(LOGIN_SUCCESS);
          resolve();
        }, 10);
      });
    },
    logout({
             commit
           }) {
      localStorage.removeItem("token");
      localStorage.removeItem("role");
      localStorage.removeItem("permissions");
      commit(LOGOUT);
    },
    updatePermissions({commit}, payload) {
      localStorage.setItem("role", payload.role);
      localStorage.setItem("permissions", payload.permissions);
      commit(UPDATE_PERMISSIONS);
    }
  },
  getters: {
    isLoggedIn: state => {
      return state.isLoggedIn;
    },
    permissions: state => {
      if (state.permissions == null) { return []; }
      if (state.permissions.length === 0) { return []; }
      return state.permissions.split(',');
    },
  }
});



// WEBPACK FOOTER //
// ./src/store/index.js